import { render, staticRenderFns } from "./MUserListDetail.vue?vue&type=template&id=1595296b&scoped=true&"
import script from "./MUserListDetail.vue?vue&type=script&lang=ts&"
export * from "./MUserListDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MUserListDetail.vue?vue&type=style&index=0&id=1595296b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1595296b",
  null
  
)

export default component.exports